export default __webpack_public_path__ + "static/media/Sneaker black.1efc44a4.png";